import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { ru } from '../language/ru.json';
import { en } from '../language/en.json';
import { es } from '../language/es.json';
import { fr } from '../language/fr.json';
import { tr } from '../language/tr.json';

Vue.use(VueI18n);

const defaultLocale = 'ru';
let currentLocale = localStorage.getItem('locale') || defaultLocale;

const i18n = new VueI18n({
    locale: currentLocale, // устанавливаем текущую локаль
    fallbackLocale: defaultLocale,
    messages: {
        ru: ru,
        en: en,
        es: es,
        fr: fr,
        tr: tr
    }
});

i18n.onLocaleChange = (newLocale) => {
    currentLocale = newLocale;
    localStorage.setItem('locale', newLocale);
};

export { i18n };
